import React, { FunctionComponent } from 'react';
import {
  ImageLinkModel,
  PrimaryLinkModel,
  SecondaryLinkModel,
  SecondaryLinkWithBoldModel,
  TitleLinkModel,
  TitleTextModel,
  TSubmenuMenuElementModel,
} from '../../models/navigationItem.model';
import PrimaryLink from './primaryLink';
import SecondaryLink from './secondaryLink';
import SecondaryLinkWithBold from './secondaryLinkWithBold';
import ImageLink from './imageLink';
import TitleLink from './titleLink';
import TitleText from './titleText';

const MenuLink: FunctionComponent<{ model: TSubmenuMenuElementModel | undefined; onClick }> = ({ model, onClick }) => {
  if (model instanceof PrimaryLinkModel) {
    return <PrimaryLink model={model} onClick={onClick} />;
  } else if (model instanceof SecondaryLinkModel) {
    return <SecondaryLink model={model} onClick={onClick} />;
  } else if (model instanceof SecondaryLinkWithBoldModel) {
    return <SecondaryLinkWithBold model={model} onClick={onClick} />;
  } else if (model instanceof ImageLinkModel) {
    return <ImageLink model={model} onClick={onClick} />;
  } else if (model instanceof TitleLinkModel) {
    return <TitleLink model={model} onClick={onClick} />;
  } else if (model instanceof TitleTextModel) {
    return <TitleText model={model} />;
  }
  return null;
};

export default MenuLink;
